<template>
  <div class="print-template">
    <!-- 3单个业务-含检测报告不含配件费明细-->
    <div id="part1">
      <h3 style="text-align:center;font-size:20px;font-weight:bold">{{printDetail.titleDetail.name}}</h3>
      <h3 style="text-align:center;font-size:20px;font-weight:bold">维修报价单</h3>
      <div style="display:flex;width:100%">
        <el-descriptions :column="1" style="width:49.5%">
          <el-descriptions-item label="TO 收件人：">{{printDetail.customerCompanyContactDetail.name}}</el-descriptions-item>
          <el-descriptions-item label="E-mail 电邮：">{{printDetail.receivingEmail}}</el-descriptions-item>
          <el-descriptions-item label="Company 公司：">{{printDetail.customerCompanyDetail.name}}</el-descriptions-item>
          <el-descriptions-item label="Tel 电话：">{{printDetail.customerCompanyContactDetail.phone}}</el-descriptions-item>
          <el-descriptions-item label="Project 报价项目：">{{printDetail.details[0].businessName}}</el-descriptions-item>
          <el-descriptions-item label="Model 型号：">{{printDetail.details[0].businessModel}}</el-descriptions-item>
        </el-descriptions>
        <el-descriptions :column="1">
          <el-descriptions-item label="Quote From 报价人：">{{printDetail.salesManDetail.name}}</el-descriptions-item>
          <el-descriptions-item label="Tel 电话：">{{printDetail.salesManDetail.phone}}</el-descriptions-item>
          <el-descriptions-item label="Line 座机：">{{printDetail.titleDetail.phone}}</el-descriptions-item>
          <el-descriptions-item label="E-Mail 电邮：">{{printDetail.salesManDetail.email}}</el-descriptions-item>
          <el-descriptions-item label="Date 日期：">{{new Date().toLocaleDateString().replace(/\//g, '-')}}</el-descriptions-item>
          <el-descriptions-item label="Quote No.业务编号：">{{printDetail.details[0].businessNo}}</el-descriptions-item>
        </el-descriptions>
      </div>
      <h4 class="form-title">工作描述：</h4>
      <div class="table-descri" >
        <div class="table-descri-li">
          <span class="table-descri-lable">设备故障现象</span>
          <span class="table-descri-content">{{printDetail.fault}}</span>
        </div>
        <div class="table-descri-li">
          <span class="table-descri-lable">初步检测情况</span>
          <span class="table-descri-content">{{printDetail.checkDes}}</span>
        </div>
        <div class="table-descri-li">
          <span class="table-descri-lable">损坏元件</span>
          <span class="table-descri-content">{{printDetail.changeParts}}</span>
        </div>
      </div>
      <h4 class="form-title">报价明细：</h4>
    </div>
    <vxe-table
      border
      show-footer
      ref="xTable"
      align="center"
      class="mt-20"
      :print-config="tablePrint"
      keep-source
      auto-resize
      :column-config="{ resizable: true }"
      :footer-method="footerMethod"
      :seq-config="{ seqMethod }"
      :merge-footer-items="mergeFooterItems"
      :data="printDetail.details"
      >
      <!-- <vxe-column width="100" title="项目" field="no"/> -->
       <vxe-column field="index" width="50" title="序号">
        <template #default="{ row }">
          No.{{row.index}}
        </template>
       </vxe-column>
      <vxe-column field="businessName" title="名称" min-width="120"/>
      <vxe-column field="amount" title="数量" width="60" />
      <vxe-column field="price" title="含税单价" min-width="100" header-align="center">
        <template #default="{ row }">
          {{$currency(row.price)}}
        </template>
      </vxe-column>
      <vxe-column field="totalPrice" title="含税总价" min-width="100" header-align="center">
        <template #default="{ row }">
          {{$currency(row.price * row.amount)}}
        </template>
      </vxe-column>
      <vxe-column field="mark" title="备注" min-width="100" >
         <!-- <template #default="{}">
          {{getTaxRateLabel(printDetail.taxRate)}}
        </template> -->
      </vxe-column>
    </vxe-table>
    <div id="part2">
      <h4 class="form-title">备注：</h4>
      <pre>{{printDetail.quotationMarkTemplateDetail.mark}} </pre>
      <div style="display:flex;width:100%;margin-top:100px;">
        <div style="width:49%">
          客户代表方签字：<span class="sign-container-border" />
        </div>
        <div style="position:relative">
          业务签字：<span class="sign-container-border" />
          <ZPreview :authSrc="printDetail.titleDetail.sealImg" width="100px" height="100px" class="upload-file_preview" />
        </div>
      </div>
    </div>
  </div>
</template>
<script  lang="ts">
import { defineComponent, reactive, toRefs } from 'vue'
import ZPreview from '@/components/common/ZPreview.vue'
import { VxeTablePropTypes } from 'vxe-table'
import { descriptionStyle, signContainer } from '@/utils/print'

import mixin from './mixin'

export default defineComponent({
  components: {
    ZPreview
  },
  props: {
    detail: { type: Object, required: true, default: () => null }
  },
  setup(props) {
    const dataMap = reactive({
      printStyle: descriptionStyle + signContainer,
      mergeCells: [
        { row: 0, col: 6, rowspan: props.detail.length, colspan: 1 }
      ] as VxeTablePropTypes.MergeCell[],
      mergeFooterItems: [
        { row: 0, col: 0, rowspan: 1, colspan: 4 }
      ] as VxeTablePropTypes.MergeFooterItems
    })
    const printMixin = mixin(props, dataMap)
    const footerMethod: VxeTablePropTypes.FooterMethod = ({ columns, data }) => {
      const sums: any[] = []
      columns.forEach((column, columnIndex) => {
        if (columnIndex === 0) {
          sums.push('合计（RMB）')
        } else {
          let sumCell: any = null
          switch (column.field) {
            // case 'price':
            //   sumCell = $currency(sumNum(data, column.field))
            //   break
            case 'totalPrice':
              sumCell = printMixin.sumTotalNum(data, 'price', 'amount')
              break
            case 'amount':
              sumCell = printMixin.sumNum(data, column.field, false)
              break
            case 'mark':
              sumCell = printMixin.getTaxRateLabel(props.detail.taxRate)
              break
          }
          sums.push(sumCell)
        }
      })
      // 返回一个二维数组的表尾合计
      return [sums]
    }

    return {
      ...printMixin,
      ...toRefs(dataMap),
      footerMethod
    }
  }
})
</script>
<style lang="scss">
.print-template{
  .table-descri{
    .is-bordered-label{
      width: 180px;
      background: #fff;
    }
  }
  .sign-container-border{
    border: 1px solid rgba(0,0,0,.7);
    height: 0px;
    width: 200px;
    display: inline-block;
  }
  .upload-file_preview{
    position: absolute;
    top: -45px;
    left: 130px;
  }
  pre {
    white-space: pre-wrap;
    word-break: break-all;
    max-width: 100%;
    font-family: inherit;
  }
  #part1, #part2 {
    max-width: 100%;
  }
}

</style>
